import { Observable } from 'rxjs';

export function downloadFile(blob: Blob, filename: string): void {
  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
    (window.navigator as any).msSaveOrOpenBlob(blob, filename);
    return;
  }

  // Create data URL for blob
  const dataUrl = window.URL.createObjectURL(blob);

  // Create anchor element for downloading blob
  const fakeLink = document.createElement('a');
  fakeLink.href = dataUrl;
  fakeLink.download = filename;

  // Dispatch click event on anchor
  // For Firefox it is necessary to delay revoking the ObjectURL
  const fakeEvent = document.createEvent('MouseEvents');
  fakeEvent.initEvent('click', false, true);
  setTimeout(() => fakeLink.dispatchEvent(fakeEvent), 100);
}

export function readBlob(blob: Blob): Observable<ArrayBuffer | string | null> {
  return new Observable((subscriber) => {
    const reader = new FileReader();

    reader.onload = () => {
      subscriber.next(reader.result);
      subscriber.complete();
    };

    reader.onerror = (error) => {
      subscriber.error(error);
    };

    reader.readAsArrayBuffer(blob);
  });
}
